import { isNil } from 'lodash-es';
import { DataPresentation } from '@/constants/data-presentation.constans';

export const yesNo = (value?: boolean) => (value ? 'Yes' : 'No');

export const formatOutput = (coreData: string, secondaryData: string, delimiter: DataPresentation) => {
  if (secondaryData?.length) {
    if (delimiter === DataPresentation.RoundBrackets) {
      return `${coreData}: (${secondaryData})`;
    }
    return `${coreData}: ${secondaryData}`;
  }
  return secondaryData;
};

// TODO can we replace with toStringValue?
export const formatValue = (value?: string | number | null) => {
  return value || '-';
};

export const toStringValue = (value: unknown, unit: string = ''): string => {
  return isNil(value) ? '-' : String(`${typeof value === 'number' ? +value.toFixed(2) : value}${unit}`);
};

export const getPluralLabel = (count: number, singularLabel: string, verb?: string) => {
  const noun = count === 1 ? singularLabel : `${singularLabel}s`;

  if (!verb) return `${count} ${noun}`;

  const verbMap: Record<string, string> = {
    was: count === 1 ? 'was' : 'were',
    is: count === 1 ? 'is' : 'are',
  };

  const pluralVerb = verbMap[verb] || (count === 1 ? `${verb}s` : verb);

  return `${noun} ${pluralVerb}`;
};

export const getNewLine = () => '\n';

export const joinWithNewline = (...args: string[]) => {
  return args.filter(Boolean).join(getNewLine());
};

export const formatNumberOrdinal = (n: number) => {
  const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });
  const suffixes = new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
  ]);
  const rule = pr.select(n);
  const suffix = suffixes.get(rule);
  return `${n}${suffix}`;
};
